import React, { useState, useRef, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from 'tea-component';
import { debounce } from 'lodash-es';
// import { select2 } from '@/utils/interface';
import { importImg } from './utils'

import DropDownList from './DropDownList';
import { GLOBAL, GLOBAL_NO_CHINA } from './contants';

import { getPosition } from './utils';
// import { compareTxt } from '@/utils/utils'
import { setLocale, getLocaleText, setLocalTexts } from '@/pages/home/components/RegionSelect/locale'
import { RegionSelectProps } from './type';
import RegionSelectInput from '@/pages/home/components/RegionSelect/RegionSelectInput';
import * as styles from './index.module.less';

console.log('styles', styles);

const RegionSelect = (props: RegionSelectProps) => {
  const { locale = 'en-US', localeTexts = {}, activeTab = 'common', onTabChange } = props

  setLocale(locale)
  setLocalTexts(localeTexts)

  const {
    value: valueProps,
    type,
    page,
    style,
    showChinese = true,
    popularList = [
      'Brazil',
      'Mexico',
      'Russia',
      'Turkey',
      'United States',
    ],
    className,
    dropdownClassName,
    defaultValue: defaultValueProps,
    defaultList,
    regionType,
    globalMessageHidden = false,
    ifDiyPosition = false,
    globalMsg,
    globalDes,
    resultLable = [getLocaleText('title_region'), getLocaleText('title_country')],
    onChange,
    onConfirm,
    disableNoChina = false,
    hiddenNoChina = false,
    regionCountry,
    title = [getLocaleText('title_region'), getLocaleText('title_country')],
    globalNodataText = getLocaleText('global_no_data_text'),
    unidentifiedNoDataText = getLocaleText('global_no_data_text'),
    closeAutoPosition = false,
    showDismissIcon = true, /**hover时是否展示删除按钮 */
  } = props;
  const containerId = useRef(`region-select-${Date.now()}`);
  const boxId = useRef(`region-select-box-${Date.now()}`);

  const [result, setResult] = useState({
    region_type: regionType,
    regions: valueProps || defaultValueProps,
    regionMarketNames: valueProps || defaultValueProps,
  } as {
    region_type: string;
    regions: string[];
    regionMarketNames: string[];
  });

  const hasSelected = result?.regions?.length > 0 && result?.regions[0] !== GLOBAL;
  const [resultLength, setResultLength] = useState({
    regions: 0,
    markets: 0,
  } as any);
  const [globalText, setGlobalText] = useState('');
  const [active, setActive]: any = useState(null);
  const [list, setList] = useState([] as any);
  const [loading, setLoading] = useState(true);
  const [recentList, setRecentList] = useState([] as any);
  const [position, setPosition] = useState({} as any);
  const [value, setValue] = useState(null as any);
  const [defaultValue] = useState(
    defaultValueProps?.map((item) => item?.toLowerCase()),
  );
  const [iconHover, setIconHover] = useState(false);
  const [deleteFlag, setDeleteFlag] = useState({
    delete: false,
  });
  const [confirmFlag, setConfirmFlag] = useState({
    num: 0,
    flag: false,
  });
  const [initFlag, setInitFlag] = useState(false)
  const dataInit = () => {

    const recentList: any[] = [];
    const filterList = (regionCountry as any || [])?.map((region: any) => {
      const children = region?.country?.map((market: any) => {
        // 过滤 id 为空的项
        if (!market?.country_name_abbre) return null
        const filterMarket = {
          id: market?.country_name_abbre.toLowerCase(),
          name: market?.country_name_en,
          cnname: market?.country_name_cn,
        };

        if (popularList?.includes(market?.country_name_cn) || popularList?.includes(market?.country_name_en) || popularList?.includes(market?.country_name_abbre?.toLowerCase())) {
          recentList.push(filterMarket);
        }
        return filterMarket;
      });
      // 过滤 id 为空的项
      if (!region?.region_key) return null

      return {
        id: region?.region_key,
        name: region?.region_name_en,
        cnname: region?.region_name_cn,
        children: children?.filter((item: any) => item !== null),
      };
    });

    // recentList.sort((a, b) => (compareTxt(b.name, a.name) ? 1 : -1)); // 按国家英文名称字母升序
    setRecentList(recentList);
    setList(changeChinaIndex(filterList?.filter((item: any) => item !== null)));
    setLoading(false);
  };

  const changeChinaIndex = (filterList: any[]) => {
    const newFilterList = [...filterList]
    const chnIndex = newFilterList?.findIndex((region) => region?.id === 'chn')
    const hmtIndex = newFilterList?.findIndex((region) => region?.id === 'hmt')
    const temp = { ...newFilterList[chnIndex] }

    newFilterList[chnIndex] = newFilterList[hmtIndex]
    newFilterList[hmtIndex] = temp
    return newFilterList
  }

  // 获取 regions/markets 的长度
  const getResultDataLength = (selectList: any) => {
    const { markets } = selectList;
    let regionLength = 0;
    let marketLength = markets === undefined ? 0 : markets?.length;
    let isRegionSelectAll = true;
    const regionMap: any = {};

    if (marketLength <= 0) {
      return {
        regionLength,
        marketLength,
      };
    }

    list?.forEach((region: any) => {
      region?.children?.forEach((market: any) => {
        if (!markets?.includes(market?.id)) return;
        if (!regionMap[region?.id]) {
          regionMap[region?.id] = {
            selectList: [],
            children: region?.children,
          };
        }
        regionMap[region?.id].selectList.push(market?.id);
      });
    });

    for (const regionId in regionMap) {
      const regionMapItem = regionMap[regionId];
      if (regionMapItem?.children?.length > regionMapItem?.selectList?.length) {
        isRegionSelectAll = false;
      } else {
        ++regionLength;
      }
    }
    return {
      regionLength: regionLength === 0 ? null : regionLength,
      marketLength: isRegionSelectAll ? null : marketLength,
    };
  };

  // 组装成接口需要的数据格式
  const filterData = (selectList: any) => {
    // region为大写，取的是region_key
    const resultRegions = selectList?.regions?.map((region: string) =>
      region,
    );
    // market为小写
    const resultMarkets = selectList?.markets?.map((market: string) =>
      market?.toLowerCase(),
    );

    let isSelectFullMarkets: null | boolean = null;
    let regionNames: string[] = [];
    let marketNames: string[] = [];

    const marketsAllLength = (() => {
      let length = 0;
      list?.forEach((region: any) => {
        if (selectList?.regions?.includes(region?.id)) {
          regionNames = [...regionNames, region?.name] // regions英文全称

          const children = region?.children;

          for (let i = 0; i < children?.length; i++) {
            const market = children[i];
            if (selectList?.markets?.includes(market?.id)) {
              marketNames = [...marketNames, market?.name] // markets英文全称
            }
          }

          // 判断 region 下的 markets 有没有选全
          if (isSelectFullMarkets !== false) {
            for (let i = 0; i < children?.length; i++) {
              const market = children[i];
              isSelectFullMarkets = true;
              if (!selectList?.markets?.includes(market?.id)) {
                isSelectFullMarkets = false;
                break;
              }
            }
          }
        }

        if (region?.children && Array.isArray(region?.children)) {
          length += region?.children?.length;
        }
      });
      return length;
    })();
    let region_type = 'market';
    let regions = resultMarkets;
    // let region_type = resultMarkets?.length === 0 && resultRegions?.includes('Unidentified') ? 'region' : 'market';
    // let regions = resultMarkets?.length === 0 && resultRegions?.includes('Unidentified') ? resultRegions : resultMarkets;
    let regionMarketNames = marketNames;

    // 问号后的是单选地区'未分类国家'，冒号后面的是默认情况

    // 每个 region 下的 markets 全选时
    // 选择所有 markets 时
    // 选择 global 时
    if (
      isSelectFullMarkets ||
      resultMarkets?.length === marketsAllLength
    ) {
      region_type = 'region';
      regions = resultRegions;
      regionMarketNames = regionNames;
    }
    if (
      resultRegions[0]?.toUpperCase() === GLOBAL?.toUpperCase() ||
      resultRegions[0]?.toUpperCase() === GLOBAL_NO_CHINA?.toUpperCase()
    ) {
      region_type = 'region';
      regions = [resultRegions[0]];
    }
    if (resultRegions?.length === 1 && resultRegions[0] === 'Unidentified') {
      region_type = 'region';
      regions = resultRegions;
      regionMarketNames = regionNames;
    }

    if (region_type == 'market' && resultRegions?.includes('Unidentified')) resultMarkets?.push('Unidentified');

    const result: {
      region_type: string;
      regions: string[];
      regionMarketNames: string[];
      renderList: any
    } = {
      region_type,
      regions,
      regionMarketNames,
      renderList: selectList?.renderList
    };
    return result;
  };

  const handleChange = (selectList: any) => {
    const result = filterData(selectList);

    // 传出结果
    setResult(result);
    onChange?.(result);
    const { regionLength, marketLength } = getResultDataLength(selectList);
    setResultLength({
      regions: regionLength,
      markets: marketLength,
    });
    if (selectList.regions[0]?.includes('global')) {
      const globalMap = {
        [GLOBAL]: `${showChinese ? '地区 ' : ''}${`<span class=${styles['region-value-left']}>${resultLable[0]}</span>`} ${globalDes ? globalDes : getLocaleText('global')}`,
        [GLOBAL_NO_CHINA]: `${showChinese ? '地区 ' : ''}${`<span class=${styles['region-value-left']}>${resultLable[0]}</span>`} ${getLocaleText('global_except_china')}`,
      };
      setGlobalText(globalMap[selectList.regions[0]]);
    } else {
      setGlobalText('');
    }
  };

  // TODO: 固定到全局的逻辑：设置 dropDown 坐标
  // const setDropDownPosition = () => {
  //   const oTargetElement: any = document.getElementById(containerId?.current);
  //   const oScrollContainer: any =
  //     document.getElementsByClassName('tea-tabs__tabpanel')[0];
  //   setPosition(getPosition(oTargetElement, oScrollContainer));
  // };

  const ducumentWidth = document.documentElement?.offsetWidth;

  // 设置 dropDown 坐标
  const setDropDownPosition = () => {
    if (closeAutoPosition) {
      return;
    }
    const oTargetElement: any = document.getElementById(containerId?.current);
    const { left } = getPosition(oTargetElement, document.documentElement);
    const ducumentWidth = document.documentElement?.offsetWidth;
    const isEnough = ducumentWidth - left >= 700;
    // console.log('600 + 20 + left - document.documentElement?.offsetWidth', 600 + 20 + left - ducumentWidth + 36)
    const leftNum = (600 + 20 + left - ducumentWidth + 36) > 325 ? 325 : 600 + 20 + left - ducumentWidth + 36;
    if (!isEnough) {
      setPosition({
        ...position,
        // left: 256 - 600 + 10, // 600 dorpdown 的宽，256 搜索框的宽，+10才能对齐，10是搜索框margin-left的距离
        left: ifDiyPosition ? -leftNum : 256 - 600 + 10, // 右边位置不足时，是否用独特定位到右对齐距离20px距离，否则用常规距离
      });
    } else {
      setPosition({
        ...position,
        left: 0,
      });
    }
  };

  useEffect(() => {
    if (ifDiyPosition) {
      window.addEventListener('resize', setDropDownPosition, false);
      return () => {
        window.removeEventListener('resize', setDropDownPosition);
      };
    }
  }, [ducumentWidth]);

  // 显示/隐藏下拉框
  const toggleDropDown = (show?: boolean) => {
    const root: any = document.getElementById('root');
    const removeElement = () => {
      const container: any = document.getElementById('region-select-root');
      root?.removeChild(container);
    };

    if (show !== undefined && !show) {
      removeElement();
      return;
    }

    setDropDownPosition();
    // 若当前为隐藏则创建容器，设置 dropDown 位置，否则删除容器
    if (!active) {
      const hasContainer = document.getElementById('region-select-root');
      if (!hasContainer) {
        const container: any = document.createElement('div');
        container.id = 'region-select-root';
        // container.style.cssText =
        //   'position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;z-index: 10;';
        root?.appendChild(container);
      }
    } else {
      // removeElement();
    }
  };

  // 激活下拉框
  const handleActive = debounce((show?: boolean) => {
    if (show !== undefined) {
      setActive(show);
    } else {
      setActive(!active);
    }
    setDropDownPosition();
  });

  // 下拉标移入变清除按钮
  const handleMouseEnter = () => {
    setIconHover(true);
  };

  // 删除标移出变下拉按钮
  const handleMouseLeave = () => {
    setIconHover(false);
  };

  // 删除按钮点击
  const handleDelete = useCallback(
    (e: any) => {
      // 阻止冒泡
      e?.stopPropagation();
      e?.preventDefault();
      // 延迟，在弹窗关闭后才清空
      setDeleteFlag({
        delete: true,
      });

      // 关闭状态下也需要传出 result
      if (!active) {
        setConfirmFlag({
          flag: true,
          num: Date.now(),
        });
      }
    },
    [active],
  );
  const registeClickEvent = () => {
    const oTeaDropDowns = document.getElementsByClassName('tea-dropdown');
    const dateDropDowns = document.getElementsByClassName('tea-datepicker');

    // 页面点击事件回调
    const documentClick = (e: any) => {
      // 点击弹窗外关闭弹窗
      const isClickInside = (() => {
        let flag = false;

        // safari 没有 path 属性此处做兼容
        if (e?.path) {
          e?.path?.forEach((item: any) => {
            if (item?.id?.includes(boxId.current)) {
              flag = true;
            }
          });
        } else {
          const findTargetParent = (target: any) => {
            if (target) {
              if (target?.id?.includes(boxId.current)) {
                flag = true
              }
              findTargetParent(target?.parentNode)
            }
          }
          findTargetParent(e.target)
        }

        return flag;
      })();
      if (!isClickInside && active) handleActive(false);
    };

    return {
      registe: () => {
        // 监听 tea-component 的下拉框点击事件
        ([] as any[]).forEach.call(oTeaDropDowns, (teaDropDown: any) => {
          teaDropDown.addEventListener('click', documentClick);
        });
        ([] as any[]).forEach.call(dateDropDowns, (teaDropDown: any) => {
          teaDropDown.addEventListener('click', documentClick);
        });


        // 监听全局的点击事件
        window?.addEventListener('click', documentClick);
      },
      unRegiste: () => {
        ([] as any[]).forEach.call(oTeaDropDowns, (teaDropDown: any) => {
          teaDropDown.removeEventListener('click', documentClick);
        });
        ([] as any[]).forEach.call(dateDropDowns, (teaDropDown: any) => {
          teaDropDown.removeEventListener('click', documentClick);
        });

        window?.removeEventListener('click', documentClick);
      },
    };
  };

  useEffect(() => {
    dataInit();
  }, [JSON.stringify(regionCountry), JSON.stringify(popularList)]);

  useEffect(() => {
    const { registe, unRegiste } = registeClickEvent();
    registe();

    return () => {
      // 卸载事件
      unRegiste();
    };
  }, [active]);

  useEffect(() => {
    if (!valueProps) return;
    setValue(valueProps);
    if (!valueProps?.length) dataInit(); // 修复舆情 cancel重置筛选器不生效
  }, [valueProps]);

  useEffect(() => {
    if (!active && initFlag) {
      onConfirm?.(result);
    }
  }, [active]);

  useEffect(() => {
    if (confirmFlag?.flag) {
      onConfirm?.({
        region_type: 'region',
        regions: ['GLOBAL'],
      });
      setConfirmFlag({
        flag: false,
        num: Date.now(),
      });
    }
  }, [confirmFlag?.num]);

  useEffect(() => {
    if (active) {
      setInitFlag(true)
    }
  }, [active])

  return (
    <div className={styles['container']} id={boxId.current}>
      <div
        id={containerId.current as any}
        className={`
          ${styles['result-container']}
          ${className || ''}
        `}
        style={style || {}}
        onClick={() => handleActive()}
      >
        <RegionSelectInput
          globalText={globalText}
          resultLength={resultLength}
          showChinese={showChinese}
          result={result}
          resultLable={resultLable} />
        {(showDismissIcon && (iconHover && hasSelected) ? (
          <Icon
            onMouseLeave={handleMouseLeave}
            onClick={handleDelete}
            className={styles['icon']}
            type="dismiss"
          />
        ) : (
          <Icon
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={styles['icon']}
            type="arrowdown"
          />
        ))}
      </div>
      <div
        id={containerId.current + 'drop-down'}
        className={`
          ${styles['drop-down-pannel']}
          ${dropdownClassName}
        `}
        style={
          (!active && {
            display: 'none',
            left: position.left,
          }) || {
            left: position.left,
          }
        }
      >
        <DropDownList
          list={list}
          value={value}
          title={title}
          globalDes={globalDes}
          activeTab={activeTab}
          defaultValue={defaultValue}
          showChinese={showChinese}
          deleteFlag={deleteFlag}
          regionType={regionType}
          loading={loading}
          panelActive={active}
          recentList={recentList}
          onChange={handleChange}
          onTabChange={onTabChange}
          globalMessageHidden={globalMessageHidden}
          globalMsg={globalMsg}
          disableNoChina={disableNoChina}
          hiddenNoChina={hiddenNoChina}
          globalNodataText={globalNodataText}
          unidentifiedNoDataText={unidentifiedNoDataText}
        />
      </div>
      {/* TODO: 挂载到全局功能延后 */}
      {/* {active &&
        createPortal(
          <div
            id={containerId.current + 'drop-down'}
            className={`
              ${styles['drop-down-pannel']}
            `}
            style={{
              left: position.left,
              top: position.top,
            }}
          >
            <DropDownList
              list={list}
              value={value}
              defaultValue={defaultValue}
              regionType={regionType}
              loading={loading}
              recentList={recentList}
              onChange={handleChange}
            />
          </div>,
          document.getElementById('region-select-root') as any,
        )} */}
    </div>
  );
};

export default RegionSelect;
